<template>
  <div class="bg">
    <div class="header">
      <fp_title :title="title"></fp_title>
      <title_button :state="state"></title_button>
      <logos></logos>
      <div class="tips">{{tips}}
        <div class="video" v-if="video">
          <my_button :value="'点击进入CodeQuest颁奖典礼(9月17日10:00)'" :inputStyle="videoStyle" @click.native="jumpVideo(true)"></my_button>
          <!-- <my_button :value="'备用直播间'" :inputStyle="videoStyle" @click.native="jumpVideo(false)"></my_button> -->
        </div>
      </div>
    </div>
  </div> </template>
<script>
import FPTitle from '@/components/frontpage/Title.vue';
import TitleButton from '@/components/frontpage/TitleButton.vue'
import MyButton from '@/components/Button.vue';
import Logos from '@/components/frontpage/TitleLogo.vue';
import moment from 'moment';

export default {
  name: 'FPHeader',
  props: {
  },
  computed: {
    videoStyle () {
      return {
        'font-size': '16px',
        'height': '35px',
        'width': '25em',
        'border-radius': '5px'
      }
    },
    title() {
      return this.$store.state.frontpage.title
    },
    game_year() {
      return this.$store.state.game_year
    },
    plus() {
      if (this.game_year == '2024') {
        return false
      }
      if(this.storeUser) {
        return Object.keys(this.gameState).reduce((c, key) => {
          const keys = key.split('-')
          if(['6', '12'].includes(keys[keys.length-1])) {
            return c || (this.gameState[key].state == 1)
          }
          return c || false
        }, false)
      }
      else
        return false
   },
    cq () {
      if(this.storeUser) {
        let state = this.gameState['2026-cq']
        return state && state.state == 1
      }
    },
    aoc () {
      if(this.storeUser) {
        let state = this.gameState['2023-aoc']
        return state && state.state == 2
      }
    },
    reward() {
      if(this.storeUser)
        return Object.keys(this.gameState).reduce((c, key) => {
          if(['6', '12'].includes(key.slice(-1))) {
            return c || ([1,2,3,11,12,13].includes(this.gameState[key].state))
          }
          return c || false
        }, false)
      else
        return false
    },
    passed () {
      if(this.storeUser) {
        return Object.keys(this.gameState).reduce((c, key) => {
          if(['02', '12'].includes(key.slice(-1))) {
            return c || false
          }
          return c || (this.gameState[key].state >= 1 && this.gameState[key].state <= 2)
          /* return c || (this.gameState[key].state % 5 !== 0) */
        }, false)
      }
      else
        return false
    },
    moment() {
      return moment
    },
    storeUser() {
      return this.$store.state.auth.user
    },
    myClassroom() {
      if(this.$store.state.auth.classroom &&
         this.$store.state.auth.classroom[0] &&
         this.$store.state.auth.classroom[0].classroom_id &&
         this.$store.state.classrooms)
        return this.$store.state.classrooms[this.$store.state.auth.classroom[0].classroom_id]
      else
        return undefined
    },
    gameState() {
      return this.$store.state.auth.game_state
    },
    gameSlug() {
      return this.$store.state.game_slug
    },
    procedure() {
      return this.$store.state.procedure
    }
  },
  watch:{
    storeUser(newValue) {
      this.dispatchMatch()
    },
    passed(newValue) {
      this.dispatchMatch()
    },
    myClassroom(newValue) {
      if(newValue)
      {
        this.dispatchMatch()
      }
    }
  },
  data () {
    return {
      cc: 0,
      mock: '不模拟',
      state: 'primary-end',
      tips: 'CodeQuest 全球赛获奖情况前往导航栏CodeQuest查看,联系右下角客服获取证书',
      video: false
    }
  },
  methods: {
    jumpVideo (main) {
      let link = 'https://live.bilibili.com/21996486'
      window.open(link, '_blank')
    },
    dispatchMatch() {
      if(this.procedure == 0) {
        this.state = 'final-end'
        const today = new Date()
        if(this.cq && today.getMonth() == 7 && today.getDate() >= 15) {
          this.state = 'cq-start'
        }
        return;
      }
      else if(this.procedure == 1)
      {
        this.state = 'primary-start';
        return;
      }
      else if(this.procedure == 2)
      {
        this.state = 'primary-end';
        return;
      }
      else if (this.procedure==3)
      {
        if(this.storeUser && this.passed)
        {
          this.state = 'final-start'
        }
        else
        {
          this.state = 'primary-end'
        }
      }
      else if (this.procedure == 4) {
        this.state = 'final-end'
        return
        if(this.storeUser) {
          if(this.plus) {
            this.state = 'final-plus-prestart'
          } else if (this.aoc) {
            this.state = 'aoc-start'
          } else {
            this.state = 'final-end'
          }
        } else {
          this.state = 'final-end'
        }
      }
      else if (this.procedure == 5) {
        if(this.storeUser && this.plus) {
          this.state = 'final-plus'
        }
        else {
          this.state = 'final-end'
        }
      } else if (this.procedure == 6) {
        if (this.aoc) {
            this.state = 'aoc-start'
          } else if(this.reward) {
            this.state = 'reward-start'
          } else {
            this.state = 'final-end'
          }
      }
      if(this.aoc && (!this.plus) && this.procedure >= 4) {
        this.state = 'aoc-start'
      }
    },
    correctTime() {
      return moment(+new Date() + this.$store.state.timeDelay)
    },
  },
  mounted() {
    this.dispatchMatch()
    if (new Date() >= new Date('2025-06-01') && new Date() <= new Date('2025-06-11')) {
      this.tips = '全国决赛将于6月10日晚8点结束，请按时提交代码。'
    }
  },
  components: {
    fp_title: FPTitle,
    title_button: TitleButton,
    logos: Logos,
    my_button: MyButton
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg{

  background-image: url('/oss/images/frontpage/header-2021.png');
  background-size: 100vw;
}
.header{
  height: 34.2vw;
  /* background-image: url(~@/assets/image/frontpage/header.png); */
  background: repeating-linear-gradient(
    40deg,
    rgba(0, 0, 0, .7) 0, rgba(0, 0, 0, .7) 0.2%,
    rgba(0, 0, 0, 0.5) 0.2%, rgba(0, 0, 0, 0.5) 0.5%
  );

  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.tips{
  position: absolute;
  margin-top: 29vw;
  font-size: 2.1vw;
  /* color: #ff4; */
  color: white;
}
.notice{
  color: red;
  text-align: center;
  margin-top: .5vw;
}
.test{
  position: absolute;
  left: 10vw;
  top: 10vh;
  width: 5em;
  height: 2em;
  color: white;
  background: red;
}
.video {
  /* position: absolute;
     right: 30%;
     margin-top: 30.5vw; */
  height: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content:space-around;
}
</style>
